export default function About() {
  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation First',
      description: 'We stay ahead of technology trends to deliver cutting-edge solutions that give you a competitive advantage.'
    },
    {
      icon: 'ri-team-line',
      title: 'Client Partnership',
      description: 'Your success is our success. We work as an extension of your team to achieve your business goals.'
    },
    {
      icon: 'ri-award-line',
      title: 'Quality Excellence',
      description: 'We maintain the highest standards in code quality, security, and performance across all our projects.'
    },
    {
      icon: 'ri-time-line',
      title: 'Agile Delivery',
      description: 'Fast, iterative development cycles ensure you see results quickly and can adapt to changing needs.'
    }
  ];

  const stats = [
    { number: '200+', label: 'Projects Completed', icon: 'ri-checkbox-circle-line' },
    { number: '50+', label: 'Global Clients', icon: 'ri-global-line' },
    { number: '98%', label: 'Client Satisfaction', icon: 'ri-star-line' },
    { number: '15+', label: 'Years Experience', icon: 'ri-calendar-line' }
  ];

  const team = [
    {
      name: 'Sarah Chen',
      role: 'Chief Technology Officer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20technology%20executive%20in%20modern%20business%20attire%20with%20confident%20smile%2C%20clean%20corporate%20headshot%20on%20simple%20white%20background%2C%20professional%20business%20portrait%20with%20natural%20lighting%2C%20tech%20industry%20leader%20aesthetic&width=400&height=400&seq=team-001&orientation=squarish',
      expertise: 'Cloud Architecture'
    },
    {
      name: 'Marcus Johnson',
      role: 'Lead Software Engineer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20male%20software%20engineer%20in%20casual%20business%20attire%20with%20friendly%20expression%2C%20clean%20corporate%20headshot%20on%20simple%20white%20background%2C%20modern%20tech%20professional%20portrait%20with%20natural%20lighting%2C%20software%20developer%20aesthetic&width=400&height=400&seq=team-002&orientation=squarish',
      expertise: 'Full-Stack Development'
    },
    {
      name: 'Elena Rodriguez',
      role: 'UX Design Director',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20female%20UX%20designer%20in%20creative%20business%20attire%20with%20warm%20smile%2C%20clean%20corporate%20headshot%20on%20simple%20white%20background%2C%20modern%20design%20professional%20portrait%20with%20natural%20lighting%2C%20creative%20industry%20aesthetic&width=400&height=400&seq=team-003&orientation=squarish',
      expertise: 'User Experience'
    },
    {
      name: 'David Kim',
      role: 'Mobile Development Lead',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20mobile%20developer%20in%20modern%20casual%20attire%20with%20confident%20expression%2C%20clean%20corporate%20headshot%20on%20simple%20white%20background%2C%20tech%20professional%20portrait%20with%20natural%20lighting%2C%20mobile%20development%20specialist%20aesthetic&width=400&height=400&seq=team-004&orientation=squarish',
      expertise: 'iOS & Android'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-teal-600 font-medium mb-3 text-sm uppercase tracking-wider">About Us</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Building Software That <span className="italic">Matters</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed text-lg">
            Since 2008, Siriux Digital has been at the forefront of digital innovation, helping businesses worldwide transform their operations through custom software solutions. Our team of expert developers, designers, and strategists work together to create technology that drives real business value.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-2xl mx-auto mb-4">
                <i className={`${stat.icon} text-3xl text-teal-600`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-gray-600 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="bg-teal-600 rounded-3xl p-12 md:p-16 mb-20">
          <div className="max-w-4xl mx-auto">
            <div className="inline-block mb-6 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full">
              <span className="text-white text-sm font-medium">Our Mission</span>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              Empowering businesses through innovative technology solutions that drive growth and efficiency
            </h3>
            <p className="text-white/90 text-lg leading-relaxed mb-8">
              We believe that great software should be accessible to every business, regardless of size. Our mission is to democratize technology by providing enterprise-grade solutions with personalized service and transparent pricing.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div>
                <div className="text-white font-bold text-sm mb-1">AGILE METHODOLOGY</div>
                <div className="text-white/80 text-xs">Fast iterations</div>
              </div>
              <div>
                <div className="text-white font-bold text-sm mb-1">24/7 SUPPORT</div>
                <div className="text-white/80 text-xs">Always available</div>
              </div>
              <div>
                <div className="text-white font-bold text-sm mb-1">GLOBAL TEAM</div>
                <div className="text-white/80 text-xs">Worldwide talent</div>
              </div>
              <div>
                <div className="text-white font-bold text-sm mb-1">ON-TIME DELIVERY</div>
                <div className="text-white/80 text-xs">Reliable results</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center">Our Core Values</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
                  <i className={`${value.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center">Meet Our Leadership Team</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="group text-center">
                <div className="relative mb-6 overflow-hidden rounded-2xl">
                  <div className="w-full h-80">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h4>
                <p className="text-teal-600 font-medium text-sm mb-2">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.expertise}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
